// extracted by mini-css-extract-plugin
module.exports = {"carouselItem":"_3ZseZI1cr-0o_6clBkJJb6"};